import { useEffect, useState } from "react";
import { buildBlob } from "../../helpers/formatters";
import useFetch from "../../hooks/useFetch";
import { DemandeAssistance, Fichier } from "../../services/Api/swagger";
import { ErrorApi } from "../../types";

export interface DemandeAssistanceByNumeroAdhesion {
  numeroAdhesion: string;
  demandeAssistance: DemandeAssistance;
}
export const useDemandeRemboursement = () => {
  const [shouldExecuteDocument, setShouldExecuteDocument] = useState<boolean>(
    false
  );
  const { response, fetching, error } = useFetch<Fichier>(
    "DECLARATIONSINISTRE",
    "getDocument",
    shouldExecuteDocument
  );

  const [errorState, setError] = useState<ErrorApi | undefined>();
  const handleClickDocument = () => {
    setShouldExecuteDocument(true);
  };

  useEffect(() => {
    if (response) {
      buildBlob(response.content, "application/pdf;base64");
      setShouldExecuteDocument(false);
    }
  }, [response]);
  useEffect(() => {
    if (error) {
      setError(error);
    }
  }, [error]);
  return { handleClickDocument, fetching, errorState, setError };
};
